import { render, staticRenderFns } from "./AvianInfluenza.vue?vue&type=template&id=056ba418&"
import script from "./AvianInfluenza.vue?vue&type=script&lang=js&"
export * from "./AvianInfluenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports